import { KnmErknmFormFieldsNamesTemplatesEnum } from '../enums/KnmErknmFormFieldsNamesTemplatesEnum';

export const knmErknmErrorFieldsArrangeArray: Array<KnmErknmFormFieldsNamesTemplatesEnum> = [
  KnmErknmFormFieldsNamesTemplatesEnum.KNO_ORGANIZATION,
  KnmErknmFormFieldsNamesTemplatesEnum.RESCHEDULING_NEW_START_DATE_ID,
  KnmErknmFormFieldsNamesTemplatesEnum.RESCHEDULING_NEW_END_DATE_ID,
  KnmErknmFormFieldsNamesTemplatesEnum.RESCHEDULING_NEW_DURATION_DAYS_ID,
  KnmErknmFormFieldsNamesTemplatesEnum.RESCHEDULING_NEW_DURATION_HOURS_ID,
  KnmErknmFormFieldsNamesTemplatesEnum.ABROGATION_LINK,
  KnmErknmFormFieldsNamesTemplatesEnum.ABROGATION_REASON_ID,
  KnmErknmFormFieldsNamesTemplatesEnum.KIND_CONTROL,
  KnmErknmFormFieldsNamesTemplatesEnum.KIND_KNM,
  KnmErknmFormFieldsNamesTemplatesEnum.TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.PLAN_ID,
  KnmErknmFormFieldsNamesTemplatesEnum.START_DATE,
  KnmErknmFormFieldsNamesTemplatesEnum.STOP_DATE,
  KnmErknmFormFieldsNamesTemplatesEnum.DURATION_DAYS,
  KnmErknmFormFieldsNamesTemplatesEnum.DURATION_HOURS,
  KnmErknmFormFieldsNamesTemplatesEnum.REASONS,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_TEXT,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_DATE,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_DATE_REQUIREMENT,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATORS_VALUE,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR_VALUE,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR_AUTO,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR_FILE,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENTS,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT_ATTACHMENTS,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT_VIOLATION_EVIDENCES,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT_VIOLATION_EVIDENCES_DATE,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT_VIOLATION_EVIDENCES_DESCRIPTION,
  KnmErknmFormFieldsNamesTemplatesEnum.REASON_DOCUMENT_VIOLATION_EVIDENCES_LINK,
  KnmErknmFormFieldsNamesTemplatesEnum.APPROVE_REQUIRED,
  KnmErknmFormFieldsNamesTemplatesEnum.PROSECUTOR_ORGANIZATION,
  KnmErknmFormFieldsNamesTemplatesEnum.APPROVED,
  KnmErknmFormFieldsNamesTemplatesEnum.REJECTED_REASON_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATIONS,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_SUBJECT_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_IS_PRESENT_IN_IT_REGISTRY,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_IS_SONKO_REGISTRY,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_IS_MSP_REGISTRY,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_IS_NKO_REGISTRY,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_OGRN,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_INN,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_ORGANIZATION_NAME,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_OKVEDS,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_OKVED,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_OKVED_OKVED,
  KnmErknmFormFieldsNamesTemplatesEnum.OBJECTS,
  KnmErknmFormFieldsNamesTemplatesEnum.OBJECT,
  KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_NAME,
  KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_ADDRESS,
  KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_KIND,
  KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_SUB_KIND,
  KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_RISK_CATEGORY,
  KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_DANGER_CLASS,
  KnmErknmFormFieldsNamesTemplatesEnum.OBJECT_REGION,
  KnmErknmFormFieldsNamesTemplatesEnum.INSPECTORS,
  KnmErknmFormFieldsNamesTemplatesEnum.INSPECTOR,
  KnmErknmFormFieldsNamesTemplatesEnum.INSPECTOR_FULL_NAME,
  KnmErknmFormFieldsNamesTemplatesEnum.INSPECTOR_POSITION,
  KnmErknmFormFieldsNamesTemplatesEnum.EXPERTS,
  KnmErknmFormFieldsNamesTemplatesEnum.EXPERT,
  KnmErknmFormFieldsNamesTemplatesEnum.EXPERT_TITLE,
  KnmErknmFormFieldsNamesTemplatesEnum.EXPERT_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS,
  KnmErknmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS_ITEM,
  KnmErknmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS_ITEM_ORGANIZATION,
  KnmErknmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS_ITEM_TITLE,
  KnmErknmFormFieldsNamesTemplatesEnum.REMOTE_NOTE,
  KnmErknmFormFieldsNamesTemplatesEnum.EVENTS,
  KnmErknmFormFieldsNamesTemplatesEnum.EVENT,
  KnmErknmFormFieldsNamesTemplatesEnum.EVENT_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.EVENT_START_DATE,
  KnmErknmFormFieldsNamesTemplatesEnum.EVENT_STOP_DATE,
  KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENTS,
  KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENT,
  KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENT_MANUAL_TITLE,
  KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENT_MANUAL_NAME_NPA,
  KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENT_MANUAL_DATE_NPA,
  KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA_ERKNM_ARRAY,
  KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA_ERKNM,
  KnmErknmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA_ERKNM_MANDATORY,
  KnmErknmFormFieldsNamesTemplatesEnum.APPROVE_DOCS,
  KnmErknmFormFieldsNamesTemplatesEnum.APPROVE_DOC,
  KnmErknmFormFieldsNamesTemplatesEnum.APPROVE_DOC_APPROVE_DOC,
  KnmErknmFormFieldsNamesTemplatesEnum.PLACES,
  KnmErknmFormFieldsNamesTemplatesEnum.PLACE,
  KnmErknmFormFieldsNamesTemplatesEnum.PLACE_VALUE,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_DOCUMENTS,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_DOCUMENT,
  KnmErknmFormFieldsNamesTemplatesEnum.ORGANIZATION_DOCUMENT_VALUE,
  KnmErknmFormFieldsNamesTemplatesEnum.ACTS,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_TYPE_ACT,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_CANCELED_REASON_DESCRIPTION,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_CANCELED_REASON,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_DOCUMENTS_ATTACHMENTS,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_CREATION_ACT_DATE_TIME,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_HOLDING_DATE_TIME,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_TEMPLATE,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_OGRN,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_INN,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_ORGANIZATION_NAME,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTORS,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR_KNO_INSPECTOR,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR_FULL_NAME,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR_POSITION,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_FIO_READER,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_REFUSER_FIO,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_REFUSER_TITLE,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_ACQUAINTANCE_LACK_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_TITLE_READER,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_DURATION_DAYS,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_DURATION_HOURS,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENTS,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_INSPECTORS,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_INSPECTOR_FULL_NAME,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_START_DATE,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_STOP_DATE,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_LINK_VKS,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_LINK_VIDEO,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_UAV_TECHNOLOGIES,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_UAV_TECHNOLOGIES_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT_EVENT_UAV_TECHNOLOGIES_NAME,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISIONS,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_PUNISHMENT_NATURE,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_NUMBER_DECISION,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_DATE_DECISION,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_IS_PROSECUTION,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_KIND_DECISION,
  KnmErknmFormFieldsNamesTemplatesEnum.ACT,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_FIO_SIGNER,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_POSITION_SIGNER,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_NOTE_LAWSUITS,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_NOTE_LAWSUIT,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_NOTE_LAWSUIT_VALUE,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_NOTE_LAWSUIT_VALUE_REACT_QUILL_EDITOR,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_INSPECTORS,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_INSPECTOR,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_INSPECTOR_FULL_NAME,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_INSPECTOR_POSITION,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_ORGANIZATION_TEMPLATE,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_SUBJECT_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_OGRN,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_INN,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_ORGANIZATION_NAME,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITIES,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_SUBJECT_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_INN,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_OGRN,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_ORGANIZATION_NAME,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_FULL_NAME,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_SNILS,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_POSITION,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_COUNTRY,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_KPP,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_RAFP,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_DOCUMENT,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_RESPONSIBILITY_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_PUNISHMENT_AMOUNT,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_PUNISHMENT_AMOUNT_MEASURE,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_PUNISHMENT_TERM,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_INN_OLD,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_OGRN_OLD,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_NAME_OLD,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_POSITION_OLD,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_FULL_NAME,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_SNILS,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_STRUCTURES_NPA,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_STRUCTURES_NPA_ITEM,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_RESPONSIBLE_ENTITY_ORGANIZATION_VALUE_STRUCTURES_NPA_ITEM_VALUE,
  KnmErknmFormFieldsNamesTemplatesEnum.RESULT_DECISION_VIOLATED_MANDATORY,
  KnmErknmFormFieldsNamesTemplatesEnum.DOCUMENT_TYPE,
  KnmErknmFormFieldsNamesTemplatesEnum.DOCUMENT_ATTACHMENTS,
  KnmErknmFormFieldsNamesTemplatesEnum.APPROVE_NOTE,
  KnmErknmFormFieldsNamesTemplatesEnum.APPROVE_NOTE_APPEAL,
  KnmErknmFormFieldsNamesTemplatesEnum.DOC_TARGET_ITEM_ERVK_CONTROL_KIND_DOC_TARGET,
];
